import { useTranslation } from 'react-i18next';
import { Badge } from '@mantine/core';
import { IconCalendar } from '@tabler/icons-react';

interface CropYearBadgeProps {
  readonly year: number;
}

// Год урожая прайс-листа — серый бейдж-метаданное (как UpdatedDateBadge). Прайс-лист — это «базис + культура +
// год урожая», поэтому без года два прайс-листа одной культуры на одном базисе неразличимы. Показываем всегда,
// а не только при совпадении культур: одинаковые строки должны выглядеть одинаково.
export default function CropYearBadge({ year }: CropYearBadgeProps) {
  const { t } = useTranslation();
  return (
    <Badge
      variant="light"
      color="gray"
      tt="none"
      fw={500}
      leftSection={<IconCalendar size={12} />}
      style={{ flexShrink: 0 }}
    >
      {t('app.buy.cropYear', { year })}
    </Badge>
  );
}
